<template>
  <vs-popup class="add-price-tiers-item-to-cart-pop-up"
            id="popup"
            :title="`PRICE GUIDE (${price_details.formulation_code})`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <!-- Controls Row -->
      <div class="popup-controls-row">
        <div class="tier-toggle-block">
          <small class="block-label">Quote with tiers?</small>
          <vs-switch v-model="is_tier" icon-pack="feather" vs-icon-on="icon-check-circle"
                     vs-icon-off="icon-slash" class="mt-2 w-16">
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
        </div>

        <div v-if="price_details.incoterm" class="incoterm-info-card">
          <div class="incoterm-icon-wrap">
            <i class="feather icon-anchor incoterm-icon"></i>
          </div>
          <div class="incoterm-text">
            <span class="incoterm-label">Incoterm</span>
            <span class="incoterm-value">{{ price_details.incoterm }}</span>
          </div>
        </div>
      </div>


      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickAddItemToCart)" autocomplete="off">

          <h5 class="mb-4 mt-2">{{ price_details.type === 'Bespoke' && is_tier ? 'Live Pricing' : 'Price tiers'}}</h5>
          <vs-table stripe :data="price_details.price" class="mb-8">

            <template slot="thead">
              <vs-th>MinOQ</vs-th>
              <vs-th>MaxOQ</vs-th>
              <vs-th>Price (Excl vat {{ account_currency }})</vs-th>
              <vs-th v-if="is_tier"></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].from">
                  {{ data[indextr].from }}
                </vs-td>

                <vs-td :data="data[indextr].to">
                  {{ data[indextr].to }}
                </vs-td>

                <vs-td :data="data[indextr].price">
                  {{ data[indextr].price }}
                </vs-td>
                <vs-td v-if="is_tier">
                  <vs-button v-if="!isTierInArray(data[indextr])" @click.stop="onClickPriceTier(data[indextr])"
                             size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">
                    select
                  </vs-button>
                  <vs-button v-if="isTierInArray(data[indextr])" @click.stop="onClickRemovePriceTier(data[indextr])"
                             size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">
                    remove
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>

          <div class="vx-row mb-3" v-if="is_tier && price_details.type === 'Bespoke'">
            <div class="vx-col w-full">
              <div class="flex">
                <h5 :class="draft_pricing.length === 0 ? 'text-grey' : ''">Show draft pricing from modeling</h5>
                <vs-checkbox class="ml-2" :disabled="draft_pricing.length === 0" v-model="show_draft_pricing"></vs-checkbox>
              </div>
              <small class="text-danger" v-if="draft_pricing.length === 0">*draft pricing not available for {{ price_details.formulation_code }}</small>
              <small class="text-success" v-if="draft_pricing.length > 0">*{{ draft_pricing.length }} draft pricing avaibale for {{ price_details.formulation_code }}</small>
            </div>
          </div>

          <div class="vx-row mb-3" v-for="(draft_price, index) in draft_pricing" :key="'draft_price'+index" v-if="show_draft_pricing && is_tier">
            <div class="vx-col w-full">

              <vx-card class="mb-3" cardBorder noShadow>
                <div>
                  <p>Created at: {{ __dateTimeFormatterToDate(draft_price.created_at) }}</p>
                  <p>Note: {{ draft_price.note || 'N/A' }}</p>
                </div>
                <vs-table stripe :data="draft_price.tiers" class="mb-4 mt-2">

                  <template slot="thead">
                    <vs-th>MinOQ</vs-th>
                    <vs-th>MaxOQ</vs-th>
                    <vs-th>Price (Excl vat {{ account_currency }})</vs-th>
                    <vs-th v-if="is_tier"></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                      <vs-td :data="data[indextr].from">
                        {{ data[indextr].from }}
                      </vs-td>

                      <vs-td :data="data[indextr].to">
                        {{ data[indextr].to }}
                      </vs-td>

                      <vs-td :data="data[indextr].price">
                        {{ data[indextr].price }}
                      </vs-td>
                      <vs-td v-if="is_tier">
                        <vs-button v-if="!isTierInArray(data[indextr])" @click.stop="onClickPriceTier(data[indextr])"
                                  size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">
                          select
                        </vs-button>
                        <vs-button v-if="isTierInArray(data[indextr])" @click.stop="onClickRemovePriceTier(data[indextr])"
                                  size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">
                          remove
                        </vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
            </div>
          </div>

          <div class="vx-row mb-8 mt-8" v-if="!is_tier">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="quantity" name="quantity" :rules="'required|moq:'+min_order_quantity+'|maxoq:'+max_order_quantity" v-slot="{ errors }">
                <small class="label">Quantity needed</small>
                <vs-input  size="large" v-on:input="onTypeQuantity" v-model="createForm.quantity"  name="quantity" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Price per KG (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.price"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Total price (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.total"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')

  function initialState() {
    return {
      open: false,
      index: null,
      createForm: {},
      price_details: {},
      is_tier: true,
      tier_data: [],
      show_draft_pricing: false,
      draft_pricing: []
    }
  }

export default {
  name: 'CalculateProductPricePopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {
      type: String,
      default: '',
    }
  },
  methods:{
    async openPopup (price_details, index, customer_id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.index = index
        Object.assign(this.price_details, price_details)
        if(this.price_details.contract_price.constructor === Array) {
          this.price_details.price = this.price_details.contract_price
        }
        await this.fetchDraftBespokePricing(customer_id, price_details.id, price_details.type)
        this.open = true;
      } catch (error) {

      }
    },
    async onClickAddItemToCart () {
      try {
        if(!this.is_tier) {
          this.price_details.unit_price = this.createForm.price
          this.price_details.quantity = this.createForm.quantity
          this.price_details.quantity_from = this.createForm.quantity
          this.price_details.quantity_to = this.createForm.quantity
          this.price_details.is_tier = this.is_tier
          this.open = false
          this.$emit('changeQtyLayer', { data: this.price_details, index: this.index })
        } else {
          let quantity_array = this.tier_data.map((x, index) => {
            return {
              order : index + 1,
              quantity_from: x.from,
              quantity_to: x.to,
            }
          })
          let price_array = this.tier_data.map((x, index) => {
            return {
              order : index + 1,
              price: x.price
            }
          })
          this.price_details.quantity_array = quantity_array
          this.price_details.price_array = price_array
          this.price_details.quantity = this.tier_data.from
          this.price_details.unit_price = this.tier_data.price
          this.price_details.quantity_from = this.tier_data.from
          this.price_details.quantity_to = this.tier_data.to
          this.price_details.is_tier = this.is_tier
          this.open = false
          this.$emit('changeQtyLayer', { data: this.price_details, index: this.index })
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      // await this.$parent.onChangeQty(this.price_details, this.index)
    },
    onTypeQuantity() {
      const quantity = Number(this.createForm.quantity)
      let price;
      this.price_details.price.forEach((item, index) => {
        const max = Number(item.to)
        const min = Number(item.from)
        let matches = false
        if (index > 0 && this.price_details.price[index - 1] && Number(this.price_details.price[index - 1].to) === min) {
          matches = quantity > min && quantity <= max
        } else {
          matches = quantity >= min && quantity <= max
        }
        if(matches) {
          this.createForm.price = (Number(item.price)).toFixed(2)
          price =  Number(item.price) * quantity
        }
      })
      this.createForm.total = Number(price).toFixed(2)
    },
    onClickPriceTier(data) {
      this.tier_data.push(data)
    },
    onClickRemovePriceTier(data) {
      this.tier_data = this.tier_data.filter((x) => x !== data)
    },
    isTierInArray(data) {
      return !!this.tier_data.find((x) => x === data)
    },
    async fetchDraftBespokePricing(customer_id, formulation_id, type = 'Bespoke') {
      try {
        if(type !== 'Bespoke') {
          return
        }
        const { data } = (await CustomerRepository.getDraftBespokePriceList(150, customer_id, formulation_id)).data
        this.draft_pricing = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    }
  },
  computed: {
    min_order_quantity: function () {
      return Number(this.price_details.price[0].from)
    },
    max_order_quantity: function () {
      const price_tiers_max = Number(this.price_details.price[this.price_details.price.length -1].to)
      const min_order_qty = Number(this.price_details.min_order_quantity)
      return Number(this.price_details.price[this.price_details.price.length -1].to)
    }
  }
  ,
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .add-price-tiers-item-to-cart-pop-up >>> .vs-popup {
    min-width: 45% !important;
  }

  /* ── Controls Row ────────────────────────────── */
  .popup-controls-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.75rem;
    padding: 1rem 1.25rem;
    background: rgba(var(--vs-primary), 0.04);
    border: 1px solid rgba(var(--vs-primary), 0.1);
    border-radius: 10px;
  }

  .tier-toggle-block {
    display: flex;
    flex-direction: column;
  }

  .block-label {
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8a8fa8;
    margin-bottom: 0.4rem;
  }

  /* ── Incoterm Info Card ───────────────────────── */
  .incoterm-info-card {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.55rem 1rem 0.55rem 0.75rem;
    background: linear-gradient(135deg, rgba(var(--vs-primary), 0.12) 0%, rgba(var(--vs-primary), 0.06) 100%);
    border: 1px solid rgba(var(--vs-primary), 0.25);
    border-radius: 8px;
    transition: box-shadow 0.2s ease;
  }

  .incoterm-info-card:hover {
    box-shadow: 0 2px 12px rgba(var(--vs-primary), 0.15);
  }

  .incoterm-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    background: rgba(var(--vs-primary), 0.15);
    border-radius: 6px;
    flex-shrink: 0;
  }

  .incoterm-icon {
    font-size: 0.95rem;
    color: rgba(var(--vs-primary), 1);
  }

  .incoterm-text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }

  .incoterm-label {
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: #8a8fa8;
  }

  .incoterm-value {
    font-size: 0.95rem;
    font-weight: 700;
    color: rgba(var(--vs-primary), 1);
    letter-spacing: 0.02em;
    margin-top: 0.05rem;
  }
</style>
